/* tonton Warenkorb Design B: Drawer und /cart Seite */
(function () {
  if (window.ttCart) return;
  var consentAccepted = false;
  var busy = false;

  function routes() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add') + '.js',
      change: (r.cart_change_url || '/cart/change') + '.js'
    };
  }

  function sectionIds(root) {
    if (root && root.dataset.ttCart === 'page') return [root.dataset.section, 'cart-icon-bubble'];
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function applyConsent(scope) {
    (scope || document).querySelectorAll('[data-tt-cart] [data-cart-legal-consent-checkbox]').forEach(function (cb) {
      cb.checked = consentAccepted;
      var foot = cb.closest('.cart__ctas');
      var btn = foot && foot.querySelector('[data-cart-legal-consent-button]');
      if (btn) {
        btn.disabled = !consentAccepted;
        btn.setAttribute('aria-disabled', String(!consentAccepted));
      }
      if (foot) foot.classList.toggle('cart__ctas--requires-legal-consent', !consentAccepted);
      var express = foot && foot.querySelector('[data-tt-express]');
      if (express) {
        express.classList.toggle('is-locked', !consentAccepted);
        express.setAttribute('aria-disabled', String(!consentAccepted));
        if (consentAccepted) express.removeAttribute('inert'); else express.setAttribute('inert', '');
      }
      var hint = foot && foot.querySelector('[data-tt-express-hint]');
      if (hint) hint.hidden = consentAccepted;
    });
  }

  function focusKey(el) {
    if (!el || !el.closest || !el.closest('[data-tt-cart]')) return null;
    if (el.id) return '#' + CSS.escape(el.id);
    if (el.hasAttribute('data-tt-add')) return '[data-tt-add="' + el.getAttribute('data-tt-add') + '"]';
    if (el.getAttribute('aria-label')) return '[aria-label="' + el.getAttribute('aria-label').replace(/"/g, '\\"') + '"]';
    return null;
  }

  function restoreFocus(key) {
    var host = document.querySelector('cart-drawer.tt-cd');
    var inDrawer = host && host.classList.contains('active');
    var scope = inDrawer ? host : document.querySelector('[data-tt-cart]');
    if (!scope) return;
    var target = key ? scope.querySelector(key) : null;
    if (target && !target.getClientRects().length) target = null;
    if (!target && inDrawer) target = host.querySelector('.tt-cd__panel');
    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
  }

  function render(root, sections) {
    if (!sections) return;
    var fkey = focusKey(document.activeElement) || (window.ttCartLastKey || null);
    var drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      var fresh = parse(drawerHtml).querySelector('#CartDrawer');
      var cur = document.getElementById('CartDrawer');
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
        var host = cur.closest('cart-drawer');
        var overlay = cur.querySelector('#CartDrawer-Overlay');
        if (host && overlay) overlay.addEventListener('click', function () { host.close(); });
        if (host) host.classList.toggle('is-empty', !!cur.querySelector('.ttc--empty'));
      }
    }
    if (root && root.dataset.ttCart === 'page') {
      var id = root.dataset.section;
      if (sections[id]) {
        var next = parse(sections[id]).querySelector('[data-tt-cart]');
        if (next) {
          root.className = next.className;
          root.innerHTML = next.innerHTML;
        }
      }
    }
    var bubbleHtml = sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var b = parse(bubbleHtml).querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    applyConsent();
    restoreFocus(fkey);
    window.ttCartLastKey = null;
  }

  function rootFor(el) {
    return (el && el.closest('[data-tt-cart]')) || document.querySelector('[data-tt-cart]');
  }

  function showError(root, msg) {
    var e = root && root.querySelector('[data-tt-error]');
    if (e) { e.textContent = msg; e.hidden = false; }
  }

  function post(root, url, body, liveMsg) {
    if (busy) return Promise.resolve();
    busy = true;
    if (root) root.classList.add('is-busy');
    body.sections = sectionIds(root);
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.description) {
          showError(root, data.description);
          return;
        }
        var activeRoot = root && root.dataset.ttCart === 'page' ? root : null;
        render(activeRoot || root, data.sections);
        var live = document.querySelector('[data-tt-cart] [data-tt-live]');
        if (live && liveMsg) live.textContent = liveMsg;
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tt-cart' }); } catch (e) {}
        }
      })
      .catch(function () {
        showError(root, 'Das hat nicht geklappt. Bitte lade die Seite neu und versuche es noch einmal.');
      })
      .finally(function () {
        busy = false;
        var r = document.querySelector('[data-tt-cart].is-busy');
        if (r) r.classList.remove('is-busy');
        document.querySelectorAll('[data-tt-cart].is-busy').forEach(function (x) { x.classList.remove('is-busy'); });
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tt-cart] [data-tt-qty], [data-tt-cart] [data-tt-add], [data-tt-cart] [data-tt-org-toggle]');
    if (!t) return;
    window.ttCartLastKey = focusKey(t);
    var root = rootFor(t);
    if (t.hasAttribute('data-tt-qty')) {
      e.preventDefault();
      var q = parseInt(t.dataset.q, 10);
      post(root, routes().change, { line: parseInt(t.dataset.line, 10), quantity: q < 0 ? 0 : q }, q === 0 ? 'Artikel entfernt' : 'Menge geändert');
    } else if (t.hasAttribute('data-tt-add')) {
      e.preventDefault();
      post(root, routes().add, { items: [{ id: parseInt(t.dataset.ttAdd, 10), quantity: 1 }] }, 'Artikel hinzugefügt');
    } else if (t.hasAttribute('data-tt-org-toggle')) {
      var pick = document.getElementById(t.getAttribute('aria-controls'));
      if (!pick) return;
      var open = pick.hidden;
      pick.hidden = !open;
      t.setAttribute('aria-expanded', String(open));
      if (open) { var s = pick.querySelector('select'); if (s) s.focus(); }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-tt-cart] [data-tt-org-select]')) {
      var props = {};
      try { props = JSON.parse(t.dataset.props || '{}') || {}; } catch (err) { props = {}; }
      if (Array.isArray(props)) {
        var obj = {};
        props.forEach(function (pair) { if (pair && pair.length === 2) obj[pair[0]] = pair[1]; });
        props = obj;
      }
      props.Spendenziel = t.value;
      props._tt_org_ok = '1';
      /* Aktive Wahl im Warenkorb auch fuer die Sitzung merken, damit die naechste Produktseite derselben Art sie vorauswaehlt */
      var line = t.closest('.ttc__line');
      var href = (line && line.querySelector('a.ttc__name') && line.querySelector('a.ttc__name').getAttribute('href')) || '';
      var kind = (/^ttc-mini-/.test(t.id || '') || t.closest('.ttc__org-pick--line') || /mini/i.test(href)) ? 'mini' : 'schulranzen';
      try { sessionStorage.setItem('tt_org_' + kind, JSON.stringify({ v: t.value, a: 1 })); } catch (err) {}
      /* Partner-Link: aktive Wahl im Warenkorb geht vor die Empfehlung (snippets/tt-ref.liquid) */
      try { if (window.ttRef && window.ttRef.choose) window.ttRef.choose(kind, t.value); } catch (err) {}
      post(rootFor(t), routes().change, { line: parseInt(t.dataset.line, 10), quantity: parseInt(t.dataset.qty, 10), properties: props }, 'Organisation geändert');
    } else if (t.matches('[data-tt-cart] [data-cart-legal-consent-checkbox]')) {
      consentAccepted = t.checked;
      applyConsent();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.code !== 'Escape') return;
    var host = document.querySelector('cart-drawer.tt-cd.active');
    if (!host) return;
    var open = host.querySelector('.ttc__org-pick:not([hidden])');
    if (open && open.contains(document.activeElement)) return;
    host.close();
  });

  window.ttCart = { render: render };
})();
